module.exports = __webpack_public_path__ + "static/media/photo-left-fifth.cd15c80d.png";